var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Centered',{staticClass:"product-view"},[_c('Navigation'),_c('ProductDetailsV2',{attrs:{"productId":_vm.product}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }